import { useState, useEffect, useContext, useRef } from "react";
import { useQuery } from "@apollo/client";
import { Autocomplete, TextField } from "@mui/material";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "./Translate";
//graphql
import {
  GET_ACADEMIC_YEAR,
  GET_SCHOOL,
  GET_GROUP,
  GET_LEVEL,
  GET_USER_PAGINATION,
  GET_CLASS_BY_ACADEMICYEAT_AND_SCHOOL,
  GET_TEACHER_USER_BY_ACADEMIC_YEAR
} from "../Schema/SelectSchema";

// ============================ Select Academic YEar ============================
export function SelectAcademicYear({ selectedVal, setSelectedVal, className }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const [data, setData] = useState([])

  // Track component mount state
  const isMounted = useRef(false);

  const { refetch: refetchCustomer } = useQuery(GET_ACADEMIC_YEAR, {
    variables: {
      keyword: "",
    },
    onCompleted: ({ getAcademicYear }) => {


      if (isMounted.current) {
        setData(getAcademicYear)
      }

    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    isMounted.current = true; // Mark component as mounted
    return () => {
      isMounted.current = false; // Cleanup on unmount
    };
  }, []);

  useEffect(() => {
    let rows = [];
    if (data?.length !== 0) {
      data?.map((d) => {
        const allRows = {
          id: d?._id,
          title: d?.academic_year,
        };
        rows.push(allRows);
      });
    }
    setSelectOptions(rows);
  }, [data])

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch((prev) => !prev);
  };

  useEffect(() => {
    if (isMounted.current) {
      refetchCustomer();
    }
  }, [checkRefetch]);

  return (
    <Autocomplete
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      getOptionLabel={(option) =>
        option?.title === undefined ? t("thead_select_value") : option?.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={t("thead_select_value")}
        />
      )}
    />
  );
}
// ============================ Select school ============================
// export function SelectSchool({
//   selectedVal,
//   setSelectedVal,
//   className,
//   disabled,
// }) {
//   // Change Language
//   const { language } = useContext(AuthContext);
//   const { t } = translateLauguage(language);

//   const [selectOptions, setSelectOptions] = useState([]);
//   const [checkRefetch, setCheckRefetch] = useState(false);

//   const [data, setData] = useState([])

//   const { refetch: refetchCustomer } = useQuery(GET_SCHOOL, {
//     variables: {
//       keyword: "",
//     },
//     onCompleted: ({ getSchoolData }) => {

//       setData(getSchoolData)

//     },
//     onError: (error) => {
//       console.log(error?.message);
//     },
//   });

//   useEffect(() => {
//     let rows = [];
//     if (data?.length !== 0) {
//       data?.map((d) => {
//         const allRows = {
//           id: d?._id,
//           title: language === "en" ? d?.school_name_en : d?.school_name,
//         };
//         rows.push(allRows);
//       });
//     }
//     setSelectOptions(rows);
//   }, [data])

//   const handleSelect = (val) => {
//     setSelectedVal(val);
//     setCheckRefetch(!checkRefetch);
//   };

//   useEffect(() => {
//     refetchCustomer();
//   }, [checkRefetch]);

//   return (
//     <Autocomplete
//       disabled={disabled}
//       className={className}
//       value={selectedVal}
//       options={selectOptions}
//       onChange={(event, val) => handleSelect(val)}
//       isOptionEqualToValue={(option, value) => option.value === value.value}
//       getOptionLabel={(option) =>
//         option.title === undefined ? t("thead_select_value") : option.title
//       }
//       renderInput={(params) => (
//         <TextField
//           {...params}
//           size="small"
//           placeholder={t("thead_select_value")}
//         />
//       )}
//     />
//   );
// }

export function SelectSchool({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
  setLoading
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);
  const [data, setData] = useState([]);

  // Track component mount state
  const isMounted = useRef(false);

  const { refetch: refetchCustomer } = useQuery(GET_SCHOOL, {
    variables: {
      keyword: "",
    },
    onCompleted: ({ getSchoolData }) => {
      if (isMounted.current) {
        setData(getSchoolData);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    isMounted.current = true; // Mark component as mounted
    return () => {
      isMounted.current = false; // Cleanup on unmount
    };
  }, []);

  useEffect(() => {
    let rows = [];
    if (data?.length > 0) {
      rows = data.map((d) => ({
        id: d?._id,
        title: language === "en" ? d?.school_name_en : d?.school_name,
      }));
    }
    setSelectOptions(rows);
  }, [data, language]);

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch((prev) => !prev);
    setLoading(true)
  };

  useEffect(() => {
    if (isMounted.current) {
      refetchCustomer();
    }
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? t("thead_select_value") : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={t("thead_select_value")}
        />
      )}
    />
  );
}


// ============================ Select group ============================
export function SelectGroup({ selectedVal, setSelectedVal, className, disabled,setLoading }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const [data, setData] = useState([])

  // Track component mount state
  const isMounted = useRef(false);

  const { refetch: refetchCustomer } = useQuery(GET_GROUP, {
    variables: {
      keyword: "",
    },
    onCompleted: ({ getGroup }) => {

      if (isMounted.current) {
        setData(getGroup)
      }

    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    isMounted.current = true; // Mark component as mounted
    return () => {
      isMounted.current = false; // Cleanup on unmount
    };
  }, []);

  useEffect(() => {
    let rows = [];
    if (data?.length !== 0) {
      data?.map((d) => {
        const allRows = {
          id: d?._id,
          title: d?.group_name,
        };
        rows.push(allRows);
      });
    }
    setSelectOptions(rows);
  }, [data])

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch((prev) => !prev);
    setLoading(true)
  };

  useEffect(() => {
    if (isMounted.current) {
      refetchCustomer();
    }
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? t("thead_select_value") : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={t("thead_select_value")}
        />
      )}
    />
  );
}
// ============================ Select level ============================
export function SelectLevel({ selectedVal, setSelectedVal, className, disabled ,setLoading}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const [data, setData] = useState([])

  // Track component mount state
  const isMounted = useRef(false);

  const { refetch: refetchCustomer } = useQuery(GET_LEVEL, {
    variables: {
      keyword: "",
    },
    onCompleted: ({ getLevel }) => {

      if (isMounted.current) {
        setData(getLevel)
      }

    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    isMounted.current = true; // Mark component as mounted
    return () => {
      isMounted.current = false; // Cleanup on unmount
    };
  }, []);

  useEffect(() => {
    let rows = [];
    if (data?.length !== 0) {
      data?.map((d) => {
        const allRows = {
          id: d?._id,
          title: d?.level_name,
        };
        rows.push(allRows);
      });
    }
    setSelectOptions(rows);
  }, [data])

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch((prev) => !prev);
    setLoading(true)
  };

  useEffect(() => {
    if (isMounted.current) {
      refetchCustomer();
    }
  }, [checkRefetch]);

  return (
    <Autocomplete
      className={className}
      value={selectedVal}
      disabled={disabled}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? t("thead_select_value") : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={t("thead_select_value")}
        />
      )}
    />
  );
}
// ============================ Select multi level ============================
export function SelectMultiLevel({ selectedVal, setSelectedVal, className, disabled }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const [data, setData] = useState([])

  const { refetch: refetchCustomer } = useQuery(GET_LEVEL, {
    variables: { keyword: "" },
    onCompleted: ({ getLevel }) => {
      setData(getLevel)

    },
    onError: (error) => console.log(error?.message),
  });

  useEffect(() => {
    if (data?.length > 0) {
      let rows = data?.map((d) => ({
        id: d?._id,
        title: d?.level_name,
      }));
      setSelectOptions(rows);
    }
  }, [data])

  useEffect(() => {
    refetchCustomer();
  }, [checkRefetch]);

  return (

    <Autocomplete
      limitTags={3}
      multiple
      size="small"
      id="tags-outlined"
      disabled={disabled}
      value={selectedVal}
      className={className}
      options={selectOptions}
      onChange={(event, val) => {
        setSelectedVal(val);
      }}
      getOptionLabel={(option) => option?.title}
      // isOptionEqualToValue={() => true}
      isOptionEqualToValue={(option, value) => option.id === value.id} // Ensure uniqueness
      filterSelectedOptions
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={t("select_val")}
          fullWidth
          className={className}
        />
      )}
    />

    // <Autocomplete
    //   multiple
    //   className={className}
    //   value={selectedVal}
    //   disabled={disabled}
    //   options={selectOptions}
    //   onChange={handleSelect}
    //   isOptionEqualToValue={(option, value) => option.id === value.id} // Prevents duplicates
    //   getOptionLabel={(option) => option.title || t("thead_select_value")}
    //   renderInput={(params) => (
    //     <TextField {...params} size="small" placeholder={t("thead_select_value")} />
    //   )}
    // />
  );
}

// ============================ Select Teacher ============================
export function SelectTeacher({ selectedVal, setSelectedVal, className, disabled, setLoading }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const [data, setData] = useState([])

  // Track component mount state
  const isMounted = useRef(false);

  const { refetch: refetchCustomer } = useQuery(GET_USER_PAGINATION, {
    variables: {
      keyword: "",
      page: 1,
      limit: 10,
      pagination: false,
      role: "Teacher",
    },
    onCompleted: ({ getUserPagination }) => {

      if (isMounted.current) {
        setData(getUserPagination)
      }

    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    isMounted.current = true; // Mark component as mounted
    return () => {
      isMounted.current = false; // Cleanup on unmount
    };
  }, []);

  useEffect(() => {
    let rows = [];
    if (data?.data?.length !== 0) {
      data?.data?.map((d) => {
        const allRows = {
          id: d?._id,
          title:
            language === "en"
              ? d?.latin_name
              : d?.last_name + " " + d?.first_name,
        };
        rows.push(allRows);
      });
    }
    setSelectOptions(rows);
  }, [data])

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch((prev) => !prev);
    setLoading(true)
  };

  useEffect(() => {
    if (isMounted.current) {
      refetchCustomer();
    }
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? t("thead_select_value") : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={t("thead_select_value")}
        />
      )}
    />
  );
}
// ============================ Select class by academic year and school ============================
export function SelectClassByAcademicYearAndSchool({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
  academicYearId,
  schoolId,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const [data, setData] = useState([])

  const { refetch: refetchCustomer } = useQuery(
    GET_CLASS_BY_ACADEMICYEAT_AND_SCHOOL,
    {
      variables: {
        academicYearId: academicYearId ? academicYearId : "",
        schoolId: schoolId,
      },
      onCompleted: ({ getClassByAcademicYearAndSchool }) => {

        setData(getClassByAcademicYearAndSchool)


      },
      onError: (error) => {
        console.log(error?.message);
      },
    }
  );

  useEffect(() => {
    let rows = [];
    if (data?.length !== 0) {
      data?.map((d) => {
        const allRows = {
          id: d?._id,
          title:
            d?.level_id?.level_name + " " + `(${d?.group_id?.group_name})`,
        };
        rows.push(allRows);
      });
    }
    setSelectOptions(rows);
  }, [data])

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetchCustomer();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? t("thead_select_value") : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={t("thead_select_value")}
        />
      )}
    />
  );
}
// ========================================================
export function SelectTeacherUserByAcademicYear({
  selectedVal,
  setSelectedVal,
  className,
  disabled,
  academicYearId,
  schoolId
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [selectOptions, setSelectOptions] = useState([]);
  const [checkRefetch, setCheckRefetch] = useState(false);

  const [data, setData] = useState([])

  const { refetch: refetchCustomer } = useQuery(
    GET_TEACHER_USER_BY_ACADEMIC_YEAR,
    {
      variables: {
        academicYearId: academicYearId ? academicYearId : "",
        schoolId: schoolId ? schoolId : ""
      },
      onCompleted: ({ getTeacherUserByAcademicYear }) => {
        // console.log("getTeacherUserByAcademicYear", getTeacherUserByAcademicYear)

        setData(getTeacherUserByAcademicYear)

      },
      onError: (error) => {
        console.log(error?.message);
      },
    }
  );

  useEffect(() => {
    let rows = [];
    if (data?.length !== 0) {
      data?.map((d) => {
        const allRows = {
          id: d?._id,
          title:
            language === "en" ? d?.latin_name : d?.last_name + " " + d?.first_name,
        };
        rows.push(allRows);
      });
    }
    setSelectOptions(rows);
  }, [data])

  const handleSelect = (val) => {
    setSelectedVal(val);
    setCheckRefetch(!checkRefetch);
  };

  useEffect(() => {
    refetchCustomer();
  }, [checkRefetch]);

  return (
    <Autocomplete
      disabled={disabled}
      className={className}
      value={selectedVal}
      options={selectOptions}
      onChange={(event, val) => handleSelect(val)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) =>
        option.title === undefined ? t("thead_select_value") : option.title
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={t("thead_select_value")}
        />
      )}
    />
  );
}
